<h2 mat-dialog-title>Restore Log</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <div class="details">
    <div class="logs-header row">
      <h5>{{ data.logsType }} Restore Log</h5>
      <button
        class="button"
        [cdkCopyToClipboard]="logsText"
        (cdkCopyToClipboardCopied)="onCopied($event)"
      >
        <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
      </button>
    </div>

    <pre class="logs">{{ logsText }}</pre>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()">
    <fa-icon [icon]="['fas', 'download']" size="lg"></fa-icon>
    Download
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
